import React from 'react';
import { TooltipBox, TooltipContent, TooltipRow } from './style';

interface InfoTooltipProps {
  details: Record<string, string>;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ details }) => {
  const displayLabels: Record<string, string> = {
    fantasia: 'Fantasia',
    cnpj: 'CNPJ',
    contato: 'Contato',
    cidadeUf: 'Cidade/UF',
    telefone: 'Telefone',
    email: 'Email',
  };

  return (
    <TooltipBox>
      <TooltipContent>
        {Object.entries(details).map(([key, value]) => {
          if (!value || value === 'Não informado' || value === 'undefined') return null;
          const label = displayLabels[key] || key;
          return (
            <TooltipRow key={key}>
              <strong>{label}:</strong> {String(value)}
            </TooltipRow>
          );
        })}
      </TooltipContent>
    </TooltipBox>
  );
};

export default InfoTooltip;
